'use strict';
import { InputStream, CommonTokenStream } from './parser/antlr4/index';
import { HCPGrammarLexer, HCPGrammarParser, HCPGrammarErrorListener } from './parser/HCPGrammarIndex';

import { VisitorParser } from './parser/VisitorParser';

export var HCPExpression;

(function() {
	var instance;
	var datatypeWithVariables;

	HCPExpression = function HCPExpression() {
		if (instance) {
			return instance;
		}

		instance = this;

		this.ValidateExpression = function(expression) {
			var expressionErrors = [];

			try {
				var chars = new InputStream(expression);
				var lexer = new HCPGrammarLexer(chars);
				var tokens = new CommonTokenStream(lexer);
				var parser = new HCPGrammarParser(tokens);
				var errorListener = new HCPGrammarErrorListener(expressionErrors);
				parser.removeErrorListeners();
				parser.addErrorListener(errorListener);
				var prgContext = parser.program();

				var visitorParser = new VisitorParser();
				try {
					visitorParser.visitProgram(prgContext);
				} finally {
					datatypeWithVariables = visitorParser.DatatypeWithVariable;
				}
			} catch (error) {
				console.log('Exception occurred while validating the expression. Error: ' + error);
			}

			return expressionErrors;
		};

		this.GetDatatypeWithVariables = function() {
			return datatypeWithVariables;
		};

		return instance;
	};
})();
